import { render, staticRenderFns } from "./school_index.vue?vue&type=template&id=d442f18e&"
import script from "./school_index.vue?vue&type=script&lang=js&"
export * from "./school_index.vue?vue&type=script&lang=js&"
import style0 from "./school_index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports